import { CmsComponentSwitch } from 'src/cms/CmsComponentSwitch';
import { ContentfulToolbar } from 'src/components/ContentfulToolbar';
import { TemplateWrapper } from 'src/templates';

import LegacyScripts from 'src/components/LegacyScripts';
import { CmsThemes, ContentfulTemplates } from 'src/lib/constants';
import { TemplateFieldShape } from 'src/lib/prop-types';
import { generateEventStructuredData } from 'src/lib/utils';

const propTypes = {
  fields: TemplateFieldShape.isRequired,
};

const EventPageTemplate = ({ fields, events }) => {
  return (
    <TemplateWrapper
      meta-title={fields?.metaTitle}
      meta-description={fields?.metaDescription}
      hasFooterCta={fields?.hasFooterCta}
      noIndex={fields?.metaNoindex}
      className='event-page'
      structuredData={generateEventStructuredData({
        name: fields?.metaTitle,
        description: fields?.metaDescription,
        startDate: fields?.startTime,
        eventStatus: fields?.eventStatus,
        eventAttendanceMode: fields?.eventAttendanceMode,
        streetAddress: fields?.streetAddress,
        addressLocality: fields?.addressLocality,
        addressRegion: fields?.addressRegion,
        postalCode: fields?.postalCode,
        addressCountry: fields?.addressCountry,
        url: fields?.url || `https://plaid.com/events/${fields?.pageSlug}/`,
      })}
      cmsTheme={CmsThemes.WEB3}
    >
      <div data-testid={ContentfulTemplates.EVENT}>
        <CmsComponentSwitch
          components={fields?.components}
          events={events}
          currentEvent={{ fields }}
          templatePage={ContentfulTemplates.EVENT}
        />
      </div>
      <LegacyScripts />
      <ContentfulToolbar />
    </TemplateWrapper>
  );
};
EventPageTemplate.propTypes = propTypes;

export default EventPageTemplate;
